// Applies a saved preference set to the page: dark/light theme and brand accent colour.
export function applyPreferences(p) {
  if (!p) return;
  try {
    const root = document.documentElement;
    root.setAttribute('data-theme', p.theme === 'dark' ? 'dark' : 'light');
    if (p.brandColor && /^#[0-9a-fA-F]{3,8}$/.test(p.brandColor)) root.style.setProperty('--brand', p.brandColor);
    else root.style.removeProperty('--brand');
    localStorage.setItem('asp_prefs', JSON.stringify({ theme: p.theme, brandColor: p.brandColor }));
  } catch { /* storage unavailable */ }
}

// Instant theme at start-up from the last saved copy, before the API answers.
export function bootPreferences() {
  try {
    const raw = localStorage.getItem('asp_prefs');
    if (raw) applyPreferences(JSON.parse(raw));
  } catch { /* ignore */ }
}
